export default "__VITE_ASSET__36PWlmEV__"